module.exports = __webpack_public_path__ + "static/Juha_Tauriainen-7b24ccd56e74f463ba1d6b6511ee0a07.jpg";